/**
 * Очевидно невалидный адрес не отправляется на сервер (MVP_PRD §8).
 *
 * Проверка намеренно нестрогая: полная валидация адреса регулярным выражением
 * невозможна (RFC 5322 допускает больше, чем ожидает любая практичная регулярка),
 * а ложный отказ на живом адресе хуже одного лишнего запроса. Финальное решение
 * всё равно за письмом: код придёт только на существующий ящик.
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isProbablyEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}
